<template>
    <div class="index_page">
        <el-menu class="nav" mode="vertical" router :default-active="$route.path">
            <div class="logo">
                <img src="../assets/img/school_logo2.png" alt="">
            </div>
            <el-menu-item index="/">
                <i class="el-icon-menu"></i>
                <span>首页</span>
            </el-menu-item>
            <el-menu-item index="/mysubscribe">
                <i class="el-icon-s-order"></i>
                <span>我的预约</span>
            </el-menu-item>
            <el-submenu v-if="userInfo.identity==1?true:false" index="appointment">
                <template slot="title">
                    <i class="el-icon-s-promotion"></i>
                    <span slot="title">预约管理</span>
                </template>
                <el-menu-item index="/pending">待审批</el-menu-item>
                <el-menu-item index="/approved">已审批</el-menu-item>
            </el-submenu>
            <el-menu-item index="/room">
                <i class="el-icon-s-home"></i>
                <span>会议室</span>
            </el-menu-item>
            <el-submenu v-if="userInfo.identity==1?true:false" index="user">
                <template slot="title">
                    <i class="el-icon-s-custom"></i>
                    <span slot="title">用户管理</span>
                </template>
                <el-menu-item index="/admin">管理员</el-menu-item>
                <el-menu-item index="/teacher">教师</el-menu-item>
            </el-submenu>
            <el-menu-item index="/email" v-if="userInfo.identity==1?true:false">
                <i class="el-icon-s-comment"></i>
                <span>群发邮件</span>
            </el-menu-item>
        </el-menu>
        <div class="page_right">
            <div class="navbar">
                <div class="title">
                    会议室预约系统
                </div>
                <el-tooltip effect="dark" content="退出登录" placement="bottom">
                    <div class="el-icon-switch-button right logout_btn" @click="logoutHandle"></div>
                </el-tooltip>
                <span class="right">{{ userInfo.real_name }}</span>
                <img src="../assets/img/default_head.png" alt="" class="right">
                <el-link type="primary" :underline="false" class="right" @click="updatePwdFormVisible = true">修改密码</el-link>
                <el-link type="primary" :underline="false" class="right" @click="updateInfoFormVisible = true">修改信息</el-link>
            </div>
            <router-view/>
        </div>
        <el-dialog title="修改密码" :visible.sync="updatePwdFormVisible" width="25%">
            <el-form :model="updatePwdForm" label-width="80px" :rules="updatePwdRules">
                <el-form-item label="原始密码" prop="oPwd">
                    <el-input v-model="updatePwdForm.oPwd" autocomplete="off" show-password></el-input>
                </el-form-item>
                <el-form-item label="新的密码" prop="nPwd">
                    <el-input v-model="updatePwdForm.nPwd" autocomplete="off" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPwd">
                    <el-input v-model="updatePwdForm.checkPwd" autocomplete="off" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updatePwdFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updatePwdHandle">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改信息" :visible.sync="updateInfoFormVisible" width="30%">
            <el-form :model="updateUserInfo" label-width="80px">
                <el-form-item label="账号">
                    <el-input v-model="updateUserInfo.username" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="updateUserInfo.real_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="updateUserInfo.tel" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="updateUserInfo.email" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateInfoFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateUserInfoHandle">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            updatePwdFormVisible: false,
            updateInfoFormVisible: false,
            updatePwdForm: {
                oPwd: null,
                nPwd: null,
                checkPwd: null
            },
            updateUserInfo: JSON.parse(localStorage.getItem('userInfo')),
            updatePwdRules: {
                oPwd: {required: true, message: '请输入原始密码', trigger: 'blur'},
                nPwd: {required: true, message: '请输入新密码', trigger: 'blur'},
                checkPwd: {required: true, message: '请确认密码', trigger: 'blur'},
            }
        }
    },
    methods: {
        // 退出登录
        logoutHandle(){
            localStorage.removeItem('jwt')
            localStorage.removeItem('userInfo')
            this.$message.success('成功退出！')
            this.$router.push('/login')
        },
        updatePwdHandle(){
            if (!this.updatePwdForm.oPwd) {
                this.$message.error('原始密码不能为空')
                return false
            } else if (!this.updatePwdForm.nPwd) {
                this.$message.error('新密码不能为空')
                return false
            } else if (!this.updatePwdForm.checkPwd){
                this.$message.error('确认密码不能为空')
                return false
            } else if (this.updatePwdForm.nPwd != this.updatePwdForm.checkPwd){
                this.$message.error('两次密码不一致')
                return false
            }
            this.$confirm('确认提交吗？')
            .then(() => {
                this.$axios.post('/user/update_pwd/', this.updatePwdForm)
                .then(res => {
                    if (res.status === 1) {
                        this.$message.success('密码已修改，请重新登录')
                        localStorage.removeItem('jwt')
                        localStorage.removeItem('userInfo')
                        this.$router.push({path: '/login'})
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        },
        updateUserInfoHandle(){
            if (!this.updateUserInfo.real_name) {
                this.$message.error('姓名不能为空')
                return false
            } else if (!this.updateUserInfo.tel) {
                this.$message.error('电话不能为空')
                return false
            } else if (!this.updateUserInfo.email) {
                this.$message.error('邮箱不能为空')
                return false
            } 
            this.$confirm('确认提交吗？')
            .then(() => {
                this.$axios.post('/user/update_user_info/', {
                    real_name: this.updateUserInfo.real_name,
                    tel: this.updateUserInfo.tel,
                    email: this.updateUserInfo.email
                })
                .then(res => {
                    if (res.status === 1) {
                        this.$message.success('修改成功')
                        let updateUserInfo = JSON.stringify(this.updateUserInfo)
                        localStorage.setItem('userInfo', updateUserInfo)
                        this.updateInfoFormVisible = false
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        }
    }
}
</script>
<style lang="less" scoped>
.index_page{
    display: flex;
    .nav{
        width: 15%;
        height: 100vh;
        .logo{
            padding: 20px 5px;
            img{
                width: 100%;
            }
        }
    }
    .page_right{
        width: 85%;
        .navbar{
            height: 50px;
            overflow: hidden;
            position: relative;
            border-bottom: 1px solid #dcdfe6;
            box-shadow: 10px 2px 12px 0 rgba(0, 0, 0, 0.1);
            .nav_btn{
                line-height: 50px;
                height: 100%;
                float: left;
                cursor: pointer;
                padding: 0px 15px;
            }
            .nav_btn:hover{
                background-color: #f9f9f9;
            }
            .title{
                line-height: 50px;
                margin-left: 20px;
                float: left;
            }
            .right{
                float: right;
                line-height: 50px;
                margin: 0 10px;
            }
            .logout_btn{
                margin-right: 50px;
            }
            img{
                width: 50px;
                height: 50px;
            }
        }
    }
}
</style>